<template>
  <div class="page" v-loading="loading">
    <h3>班级：{{ title }}</h3>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        'text-align': 'center',
        background: '#FFF7EB',
        color: '#FF7739',
      }"
    >
      <el-table-column prop="mem_id" label="学员ID" align="center" />
      <el-table-column prop="mem_name" label="姓名" align="center" />
      <el-table-column prop="mem_phone" label="手机号" align="center" />
      <el-table-column prop="mem_idcard" label="身份证号" align="center" />
      <el-table-column prop="mem_regdate" label="创建时间" align="center" />
      <el-table-column prop="jobs_submit_count" label="已提交" align="center" />
      <el-table-column prop="jobs_wait_count" label="待提交" align="center" />
    </el-table>

    <Pagination @pageChange="pageChangeFn" :total="total"></Pagination>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '../../components/Pagination'
import { getList } from '../../request/userList'

export default {
  components: { Pagination },
  setup() {
    const router = useRouter()
    const state = reactive({
      loading: false,
      tableData: [],
      total: 0,
      search: { page: 1 },
      title: '',
    })
    onMounted(() => {
      state.search.sys_class_id = router.currentRoute._value.params.id
      state.title = router.currentRoute._value.params.name
      init()
    })

    const init = async () => {
      state.loading = true
      const { data, code, msg, total } = await getList(state.search)
      state.loading = false
      if (code == 200) {
        state.tableData = data
        state.total = total
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const pageChangeFn = value => {
      state.search.page = value
      init()
    }

    return {
      ...toRefs(state),
      init,
      pageChangeFn,
    }
  },
}
</script>

<style lang="less" scoped>
.el-button {
  color: #fff;
}
</style>
